<template>
    <div>
        <div class="row mb-2">
            <div class="col-md-7">
                <filter-global-input />
            </div>
            <div class="col-md-5">
                <filter-button
                        :filterForm="filterForm"
                        :isLoading="isLoading"
                        v-on:hide="hide"
                        v-on:onColumnFilter="onColumnFilter"
                />
                <export-button />
                <approve-button />
            </div>
        </div>
        <div class="card">
            <div class="card-body card-table">
                <vue-good-table
                        :columns="columns"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                        enabled: true,
                        nextLabel: $t('table.NextLabel'),
                        prevLabel: $t('table.PrevLabel'),
                        rowsPerPageLabel: $t('table.RowsPerPageLabel'),
                        ofLabel: $t('table.OfLabel'),
                        pageLabel: $t('table.PageLabel'),
                        allLabel: $t('table.AllLabel')
                    }"
                        :rows="table.rows"
                        :selectOptions="{
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'checkbox',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                            disableSelectInfo: true, // disable the select info panel on top
                          }"
                        :sort-options="{
                            enabled: true,
                          }"
                        :styleClass="'table'+((!isCLoading) ? ' table-hover' : '')"
                        :totalRows="table.totalRecords"
                        @on-column-filter="onColumnFilter"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        mode="remote"
                        ref="measurementsTable">
                    <template slot="table-column"
                              slot-scope="props">{{ $t('measurement.'+props.column.label) }}
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'control_date'">
                            {{moment(props.row.control_date).format('D/M/Y')}}
                        </span>
                        <span v-else-if="props.column.field == 'in_date'">
                            {{moment(props.row.in_date).format('D/M/Y')}}
                        </span>
                        <span v-else-if="props.column.field == 'pollution_rate'">
                            <PollutionBar :data="props.row.pollution_rate"></PollutionBar>
                        </span>
                        <span v-else-if="props.column.field == 'wear_rate'">
                            <PollutionBar :data="props.row.wear_rate"></PollutionBar>
                        </span>
                        <span v-else-if="props.column.field == 'approved'">
                            <yes-no-badge :value="props.row.approved"></yes-no-badge>
                        </span>
                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        <span v-if="props.column.field == 'actions'">
                          <router-link v-if="props.row.relations.component" :to="{name: 'measurementUpdate', params: {
                    id: props.row.id,
                    customer_id: props.row.relations.component.relations.customer.id,
                    component_id: props.row.relations.component.id
                    }}" class="btn btn-sm btn-primary"><i class="fa fa-edit"></i></router-link>
                            <router-link v-if="props.row.relations.component" :to="{name: 'componentView', params: {
                    id: props.row.relations.component.id,
                    customer_id: props.row.relations.component.relations.customer.id
                    }}" class="btn btn-sm btn-dark ml-2"><i class="fa fa-bar-chart"></i></router-link>
                        </span>
                    </template>
                    <div slot="emptystate">
                        <span v-if="isCLoading">
                            <loader-table></loader-table>
                        </span>
                        <span v-else>
                            {{$t('table.NoData')}}
                        </span>
                    </div>
                    <template slot="loadingContent">
                        <div class="spinner-border text-secondary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import {VueGoodTable} from 'vue-good-table'
    import {mapActions, mapGetters} from 'vuex'
    import PollutionBar from "@/components/PollutionBar"
    import loaderTable from '@/components/charts/loaders/loader-table.vue'
    import YesNoBadge from '@/components/YesNoBadge'
    import ApproveButton from '@/components/ApproveButton'
    import ExportButton from '@/components/ExportButton'
    import FilterButton from '@/components/FilterButton'
    import FilterGlobalInput from '@/components/FilterGlobalInput'

    export default {
        name: 'measurementIndex',
        data() {
            return {
                isLoading: false,
                isCLoading: true,
                showFilter: false,
                filterForm: {
                    number: '',
                    name: '',
                    control_date: '',
                    type_name: ''
                },
                columns: [
                    {
                        label: 'Packet',
                        field: 'relations.component.packet_number'
                    },
                    {
                        label: 'Component',
                        field: 'relations.component.number'
                    },
                    {
                        label: 'Customer',
                        field: 'relations.component.relations.customer.name'
                    },
                    {
                        label: 'Type',
                        field: 'relations.component.relations.type.name'
                    },
                    {
                        label: 'Brand',
                        field: 'relations.component.relations.brand.name'
                    },
                    {
                        label: 'in_date',
                        field: 'in_date'
                    },
                    {
                        label: 'control_date',
                        field: 'control_date'
                    },
                    {
                        label: 'Pollution_rate',
                        field: 'pollution_rate'
                    },
                    {
                        label: 'Wear_rate',
                        field: 'wear_rate'
                    },
                    {
                        label: 'Approved',
                        field: 'approved'
                    },
                    {
                        label: 'Actions',
                        field: 'actions',
                        sortable: false,
                    }
                ]
            };
        },
        computed: {
            ...mapGetters({
                table: 'TABLE',
            })
        },
        components: {
            VueGoodTable,
            PollutionBar,
            loaderTable,
            YesNoBadge,
            ApproveButton,
            ExportButton,
            FilterButton,
            FilterGlobalInput
        },
        async mounted() {
            this.$store.dispatch('TO_DEFAULTSTATE')
            await this.loadItems()
            this.isCLoading = false
        },
        methods: {
            hide: function () {
                this.showFilter = false

            },
            show: function () {
                this.showFilter = true
            },
            ...mapActions({
                    loadItems: 'GET_MEASUREMENTS',
                }
            ),
            updateParams(newProps) {
                this.$store.dispatch('CHANGE_SERVERPARAMS', newProps)
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },
            onSortChange(params) {
                let type = params[0].type
                let field = params[0].field

                switch (field) {
                    case 'relations.component.relations.customer.name':
                        field = 'name'
                        break
                    case 'relations.component.number':
                        field = 'number'
                        break
                    case 'relations.component.packet_number':
                        field = 'packet_number'
                        break
                    case 'relations.component.relations.brand.name':
                        field = 'brand'
                        break
                    case 'relations.component.relations.type.name':
                        field = 'type_name'
                        break
                }

                this.updateParams({
                    sort: [{
                        type: type,
                        field: field,
                    }],
                });
                this.loadItems();
            },
            async onColumnFilter() {
                this.isLoading = true
                this.updateParams({filter: this.filterForm});
                await this.loadItems();
                this.isLoading = false
            },
        }
    }
</script>
